@if (ready$ | async) {
  <main class="d-flex" [class.busy]="busy">
    @if (busy) {
      <div class="busy-overlay"></div>
    }
    <app-navigation></app-navigation>
    <router-outlet></router-outlet>
  </main>
}